<script lang="ts">
  // Module dependencies
  import { SvelteHead, ReviewSection, PlanSelectSection } from '@centerhealth/fe/center-kit';
  import { REVIEWS_DATA } from '@centerhealth/fe/center-kit';

  // Sveltekit dependencies
  import { page } from '$app/stores';
  import { selectedPlan as plan } from '@centerhealth/fe/stores';
  import { goto } from '$app/navigation';

  // page info and meta
  const htmlHead = {
    title: 'Reviews | Center Health',
    description:
      "Read what real customers are saying about Center's convenience, pricing, accuracy and more",
    url: $page.url.href,
    host: $page.url.origin,
  };

  const reviews = REVIEWS_DATA;

  const planSelectHandler = async ({ detail }) => {
    // set plan to global store
    plan.set(detail);
    await goto('/subscribe');
    // location.href = '/subscribe';
  };
</script>

<SvelteHead {htmlHead} />

<ReviewSection {reviews} />
<PlanSelectSection on:card-selected={planSelectHandler}>
  <div class="text-center">
    <h2 class="text-2xl text-gray-darkest mb-1 xl:text-3xl">
      Ready to make a change? <span class="font-semibold">Get started today!</span> 🎉
    </h2>
    <h3 class="text-lg mb-5 xl:text-xl">Select how many strips per day you use ⬇️</h3>
  </div>
</PlanSelectSection>
